import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowRelatedVideosConverter extends CmsConverterService<PanelRowRelatedVideosData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      links: formData.st_panel_row_related_videos_links_list ?? defaultFSCatalog,
      text: formData.st_panel_row_related_videos_optional_text ?? defaultTextInput,
    }
  }
}

export const PANEL_ROW_RELATED_VIDEOS_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowRelatedVideosData>>('PanelRowRelatedVideosConverter')

export interface PanelRowRelatedVideosData extends ConvertedComponentData {
  links: FsCatalog;
  text: TextInput;
}
